module.exports = __webpack_public_path__ + "img/szhx_titIcon1.91c0b63e.png";